import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from 'primereact/button'
import { Column } from 'primereact/column'

import { PanelContainer } from '../../../../components/Panel'
import {
  AttachmentDownloadButton,
  AttachmentOpenInTabButton,
} from '../../../../components/attachments'
import {
  Attachment as AttachmentModel,
  WebEdiDto,
} from '../../../../data/models'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { ConfigurableTable } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config'
import { useDespatchAdviceById } from '../../data'
import { Delete, Upload } from './dialogs'

interface Props {
  despatchAdviceId: WebEdiDto['Id']
  processId: string
}

export const Attachment: React.FC<Props> = ({
  despatchAdviceId,
  processId,
}) => {
  const { t } = useTranslation()

  const { data: despatchAdvice, isLoading } =
    useDespatchAdviceById(despatchAdviceId)
  const { uiConfig: config } = useConfigContext()

  const [displayUploadAttachment, setDisplayUploadAttachment] = useState(false)

  // get all other attachments
  const otherAttachments = despatchAdvice?.Attachments.filter(
    item => item.Type.toLowerCase() === 'additional',
  )

  const actionBodyTemplate = (rowData: AttachmentModel) => {
    return (
      <>
        <Delete
          key={`att-delete-${rowData.Id}`}
          attachmentId={rowData.Id}
          attachmentUrl={rowData.Url as string}
          attachmentName={rowData.Name}
          despatchAdviceId={despatchAdviceId}
        />

        <AttachmentOpenInTabButton
          key={`att-tab-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />

        <AttachmentDownloadButton
          key={`att-download-${rowData.Id}`}
          fullUrl={rowData.Url as string}
          mimeType={rowData.MimeType as string}
          fileName={rowData.Name}
        />
      </>
    )
  }

  const headerActions = (
    <>
      {config.despatchAdvice.uploadAttachment.enabled !== false && (
        <Button
          label={t('despatchAdvice.attachments.table.upload.label')}
          onClick={() => setDisplayUploadAttachment(true)}
          icon="pi pi-upload"
          className="p-button-outlined mb-2"
        />
      )}
    </>
  )

  const attachmentButtons = (
    <Column
      key="attachmentButtons"
      body={actionBodyTemplate}
      align="right"
    ></Column>
  )

  return (
    <PanelContainer
      header={getConfigTranslation(config.despatchAdvice.attachment.title)}
      id="despatchAdvice-attachment"
      visible={config.despatchAdvice.attachment.enabled}
    >
      <>
        <ConfigurableTable
          config={config.despatchAdvice.attachment.additionalDocuments}
          data={otherAttachments}
          headerActions={headerActions}
          buttons={attachmentButtons}
          isLoading={isLoading}
          stateKey=""
        />

        <Upload
          visible={displayUploadAttachment}
          setVisible={setDisplayUploadAttachment}
          despatchAdviceId={despatchAdviceId}
          processId={processId}
        />
      </>
    </PanelContainer>
  )
}
